export default {
    state: {
        menu: [
            { product: true, title: 'Help Desk', bgcolor: 'primary' },
            {
                title: 'Queries', icon: '/img/navicon/Queries.svg', href: '/helpdesk/queries',
            },
        ],
    },
    mutations: {
    },
    actions: {
    },
    getters: {

    },
}